const FETCH_CONTENT_COLLECTION_ENTRY = 'FETCH_CONTENT_COLLECTION_ENTRY';
const FETCH_CONTENT_COLLECTION_ENTRY_FULFILLED = 'FETCH_CONTENT_COLLECTION_ENTRY_FULFILLED';
const FETCH_CONTENT_COLLECTION_ENTRY_REJECTED = 'FETCH_CONTENT_COLLECTION_ENTRY_REJECTED';

export {
  FETCH_CONTENT_COLLECTION_ENTRY,
  FETCH_CONTENT_COLLECTION_ENTRY_FULFILLED,
  FETCH_CONTENT_COLLECTION_ENTRY_REJECTED,
};
